import React, { useEffect, useState } from "react";
import styles from "../onboard.module.css";
import StudentPersonalDetails from "./studentPersonal";
import StudentDocUploads from "./documentUpload";
import { fetchDetails, statusApi } from "../../../api";
import { useMyContext } from "../../../myContext";

const Student = ({ stepToShow, setStepsToShow }) => {
  const [studentList, setStudentList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [studentCardSelection, setStudentCardSelection] = useState(false);
  const [uploadError, setUploadError] = useState("");
  const [reqDocs, setReqDocs] = useState([]);

  const [selectedRemitterData, setSelectedRemitterData] = useState({});
  const [studentLoader, setStudentLoader] = useState(false);
  const [addnewButton, setAddnewButton] = useState(false);

  const {
    setStudentSecondFlow,
    completedRemitter,
    completedStudent,
    showStudentUpload,
    completedBeneficiary,
    studentShortDetail,
    setStudentShortDetail,
    showStudentDetail,
    setShowStudentDetail,
    showPassportDetail,
    setShowPassportDetail,
    studentUserId,
    remitterUserId,
  } = useMyContext();

  const fetchRemitterData = async () => {
    try {
      const response = await statusApi(remitterUserId);
      if (response && response.data) {
        setSelectedRemitterData(response.data);
      }
    } catch (error) {
      console.log(
        "🐛 DEBUG: ~ file: student.js:44 ~ fetchRemitterData ~ error",
        error
      );
    }
  };

  useEffect(() => {
    if (remitterUserId && stepToShow === "StudentStep1") {
      fetchRemitterData();
    }
  }, [remitterUserId, stepToShow]);

  const fetchStudentData = async () => {
    try {
      fetchDetails("Student").then((response) => {
        setStudentLoader(false);
        setStudentList(response && response.data ? response.data : []);
        if (studentUserId) {
          const selectedCard = response.data.find(
            (item) => item.userAccountId === studentUserId
          );
          if (selectedCard) {
            const temporaryList = response.data.filter(
              (item) => item.userAccountId !== studentUserId
            );
            temporaryList.push(selectedCard);
            setFilteredList(temporaryList);
          }
        } else {
          setFilteredList(response.data);
        }
        if (response && response.data && response.data.length !== 0) {
          setStudentSecondFlow(true);
          setStudentCardSelection(true);
          setAddnewButton(false);
        } else {
          setStudentCardSelection(false);
          setStudentSecondFlow(false);
          setAddnewButton(true);
          if (stepToShow !== "StudentStep1") setStepsToShow("StudentStep1");
        }
      });
    } catch (error) {
      setStudentLoader(false);
    }
  };

  useEffect(() => {
    if (completedRemitter && !completedStudent && !showStudentDetail) {
      setStudentLoader(true);
      fetchStudentData();
    }
  }, [completedRemitter, completedStudent]);

  useEffect(() => {
    if (
      !completedStudent &&
      completedRemitter &&
      completedBeneficiary &&
      !showStudentDetail
    ) {
      setStudentLoader(true);
      fetchStudentData();
    }
  }, [completedRemitter, completedBeneficiary]);

  const fetchCardDetail = () => {
    setStudentCardSelection(true);
    setShowStudentDetail(false);
    setStudentLoader(true);
    fetchStudentData();
  };

  return (
    <div className={styles.cardDetails}>
      <>
        <h1 className={styles.onboardHeading}>2. Student</h1>
        {studentList.length === 0 ? (
          <>
            <StudentPersonalDetails
              selectedRemitterData={selectedRemitterData}
              stepToShow={stepToShow}
              setStepsToShow={setStepsToShow}
              shortDetail={studentShortDetail}
              setShortDetail={setStudentShortDetail}
              studentLoader={studentLoader}
              showStudentDetail={showStudentDetail}
              setShowStudentDetail={setShowStudentDetail}
              setShowPassportDetail={setShowPassportDetail}
              setReqDocs={setReqDocs}
              studentCardSelection={studentCardSelection}
              setStudentCardSelection={setStudentCardSelection}
              addnewButton={addnewButton}
              fetchCardDetail={fetchCardDetail}
              setUploadError={setUploadError}
            />
            {showStudentUpload === true && (
              <StudentDocUploads
                stepToShow={stepToShow}
                setStepsToShow={setStepsToShow}
                showPassportDetail={showPassportDetail}
                setShowPassportDetail={setShowPassportDetail}
                reqDocs={reqDocs}
                setUploadError={setUploadError}
                uploadError={uploadError}
              />
            )}
          </>
        ) : (
          <>
            <StudentPersonalDetails
              selectedRemitterData={selectedRemitterData}
              stepToShow={stepToShow}
              setStepsToShow={setStepsToShow}
              shortDetail={studentShortDetail}
              setShortDetail={setStudentShortDetail}
              studentList={filteredList}
              studentLoader={studentLoader}
              showStudentDetail={showStudentDetail}
              setShowStudentDetail={setShowStudentDetail}
              setShowPassportDetail={setShowPassportDetail}
              setReqDocs={setReqDocs}
              studentCardSelection={studentCardSelection}
              setStudentCardSelection={setStudentCardSelection}
              addnewButton={addnewButton}
              fetchCardDetail={fetchCardDetail}
              setUploadError={setUploadError}
            />
            {showStudentUpload === true && (
              <StudentDocUploads
                stepToShow={stepToShow}
                setStepsToShow={setStepsToShow}
                showPassportDetail={showPassportDetail}
                setShowPassportDetail={setShowPassportDetail}
                reqDocs={reqDocs}
                setUploadError={setUploadError}
                uploadError={uploadError}
              />
            )}
          </>
        )}
      </>
    </div>
  );
};
export default Student;
